import { QuestionTypeEnum } from '@shared/Enums/QuestionTypeEnum';
import { RawFragment } from '@entities/Fragment/Types';
import { RawTemplate } from '@entities/Template/Types';
import { RawQuestion } from '@entities/Question/Types';

export const ExtractQuestions = (
    data: RawFragment['data'] | RawTemplate['data']
): [string, RawQuestion][] => {
    return Object.entries(data).filter(
        ([_, value]) =>
            typeof value === 'object' &&
            value &&
            'select' in value &&
            value.question !== '' &&
            Object.values(QuestionTypeEnum).includes(value.select)
    ) as [string, RawQuestion][];
};
